import Command from "@ckeditor/ckeditor5-core/src/command";
import { CkeditorConstants } from "../../src/utils/ckeditorconstants";

const {
    helperAttributes: { SUBTEMPLATE_NAME },
    htmlElement : { SPAN }
} = CkeditorConstants;

export default class RemoveISTSubtemplateCommand extends Command {
    execute() {
        this.removeMarkupRemains()
    }

    /**
     * Below Logic to check IST has remains if then removes empty elements.
     */
    removeMarkupRemains() {
        this.editor.model.change((writer) => {
            [...this.getAllIST(writer)].forEach((element) => {
                this.checkChildren(writer, element);
            });
        });
    }

    /**
     * Get all IST Subsection in model document.
     */
    getAllIST(writer) {
        const range = writer.createRangeIn(
            this.editor.model.document.getRoot("main")
        );
        return [...range.getItems()].filter(
            (item) => item.name === SPAN && item._attrs && item.hasAttribute(SUBTEMPLATE_NAME)
        );
    }

    /**
     * Loops a IST children in reverse.
     */
    checkChildren(writer, element) {
        for (let i = element.childCount - 1; i >= 0; i--) {
            this.removeISTChildRemains(writer, element._children._nodes[i]);
        }
        this.removeIST(writer, element);
    }

    /**
     * Checks children element contains any textproxy in descendant.
     * If contains element omit, else removes.
     */
    removeISTChildRemains(writer, childElement) {
        if(!childElement.is("$text") && !childElement.is("$textProxy")) {
            let hasElement = false;
            const range = writer.createRangeIn(childElement);
            for (const item of range.getItems()) {
                if (item || (item.is("$text") || item.is("$textProxy"))) {
                    hasElement = true;
                    break;
                }
            }
            if (!hasElement) {
                writer.remove(childElement);
            }
        }
    }

    /**
     * Removes a empty IST subsection element.
     */
    removeIST(writer, element) {
        if (element.childCount === 0) {
            writer.remove(element);
        }
    }
}
